import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const teletracnavmandirectorConfig: TSPConfig = {
  key: 'teletracnavmandirector',
  name: 'Teletrac Navman Director',
  imageName: 'Teletrac Navman Director',
  category: TSPCategory.CREDENTIALS,
  helpText: 'Please provide your Teletrac Navman Director credentials.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        { label: 'Username', name: 'username', type: 'text', required: true },
        {
          label: 'Password',
          name: 'password',
          type: 'password',
          required: true,
        },
      ]}
    />
  ),
};

export default teletracnavmandirectorConfig;
